import { VueModule } from '@Foundation/utilities';
import { noJsHandler } from './code/Scripts/directives/noJsHandler';

export default VueModule({
  directives: {
    noJsHandler
  }
});
